import React, { useEffect, useState } from "react";
import classes from "./NotificationsMobile.module.css";
import { Container, Col, Row } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import {
  doubleTickBlueIcon,
} from "../../../constant/imagePath";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { MobileFilter } from "../../../stories/MobileFilter/MobileFilter";
import { useHistory } from "react-router-dom";
import { NotificationBox } from "../../../stories/NotificationBox/NotificationBox";
import { PaginationComponent } from "../../../stories/Pagination/Pagination";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";
// import MobileReview from "../../../components/Modals/CoachFlow/Notifications/MobileReview/MobileReview";
import { SendFeedbackModal } from "../../../components/Modals/CoachFlow/Notifications/SendFeedback/SendFeedback";
import ReportAProblemModal from "../../../components/Modals/StudentFlow/Dashboard/ReportAProblem/ReportAProblem";
import { ReviewModal } from "../../../components/Modals/CoachFlow/Reviews/ReviewModal";
import CancelLesson from "../../../components/Modals/CoachFlow/Dashboard/CancelLesson/CancelLesson";

const NotificationsMobile = () => {
  const history = useHistory();
  const [filtervalue, setFiltervalue] = useState("Show all");
  const [paginatedData, setpaginatedData] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState('')
  const [isShowModalType, setIsShowModalType] = useState('')

  console.log({ isOpenModal, isShowModalType })


  const mobileFilters = [
    "Show all",
    "Announcements",
    "Training report",
    "Profile updates",
  ];
  const staticData = [
    {
      title: "Announcement",
      type: "announcement",
      description: "Added new sports and the ability to complain about users.",
      isSeen: true,
      status: "send-feedback",
    },
    {
      title: "Training report",
      description:
        "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
      isSeen: true,
      type: "training-report",
      status: "",
    },
    {
      title: "1-on-1 Tennis Lesson",
      description: "with Ed Collins on Jul 20",
      isSeen: true,
      type: "training-request",
      status: "cancel-lesson",
      date: "July 17,2021",
    },
    {
      title: "Profile onboarding",
      description: "Your onboarding has been approved.",
      isSeen: true,
      type: "profile-update",
      status: "approved",
    },
    {
      title: "Profile onboarding",
      description:
        "Your onboarding has been declined. Since onboarding check wasn’t approved - your account remains private.",
      isSeen: true,
      type: "profile-update",
      status: "declined",
      date: "July 14, 2021",
    },
    {
      title: "Profile banned",
      description:
        "You canceled classes three times less than 24 hours before the start. Unfortunately, we are forced to ban your profile for 2 weeks. After this period, you can use our application as before.",
      isSeen: true,
      type: "profile-update",
      status: "profile-banned",
    },
    {
      title: "Profile unbanned",
      description:
        "Profile unbanned: Congratulations, your profile is active and you can book your lessons again!",
      isSeen: true,
      type: "profile-update",
      status: "profile-unbanned",
    },
    // ,
    // {
    //   title: "lesson-booked",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-booked",
    // },
    // {
    //   title: "lesson-cancelled",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-cancelled",
    // },
  ];

  const [notificationdata, setNotificationdata] = useState(staticData);
  const [menuItem, setMenuItem] = useState("notifications");


  const [currentPage, setCurrentPage] = useState(1);
  const pagelimit = 6;

  useEffect(() => {
    setpaginatedData(() => {
      const startIndex = currentPage * pagelimit - pagelimit;
      const endIndex = startIndex + pagelimit;
      return notificationdata.slice(startIndex, endIndex);
    });
  }, [currentPage]);

  return (
    <div className={[classes.NotificationScreen].join(" ")}>
      <Container fluid className={["p-0", classes.container].join(" ")}>
        <div
          className={[classes.dflex, classes.contentbetween, classes.mb16].join(
            " "
          )}
        >
          <h3
            style={{
              ...Fonts.h3,
              color: Colors.neutralShadesOfNero,
              fontSize: "24px",
              lineHeight: "32px",
            }}
          >
            Notifications
          </h3>
          <LinkButtonWithIcon
            text="Mark all as read"
            leftIcon={doubleTickBlueIcon}
            primary={true}
            customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
          />
        </div>

        <MobileFilter
          filters={mobileFilters}
          state={filtervalue}
          setter={setFiltervalue}
        />
        <Row className={["g-0", classes.row, classes.pb64].join(" ")}>
          {paginatedData.map((item, i) => {
            return (
              <Col sm={12} key={i}>
                <NotificationBox data={item}
                  onClick1={(type, status) => {
                    setIsShowModalType(type);
                    setIsOpenModal(status);
                    if (status == "go-to-onboarding")
                      history.push("/on-boarding");
                    if (status == "contact-us") history.push("/contact-us");
                    if (status == "chat") history.push("/student-chat");
                  }}
                  onClick2={(type, status) => {
                    setIsShowModalType(type);
                    setIsOpenModal(status);
                    if (status == "contact-us") history.push("/contact-us");
                  }}
                />
              </Col>
            );
          })}
          <Col sm={12}>
            <PaginationComponent
              totalPages={Math.ceil(notificationdata.length / pagelimit)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Col>
        </Row>
      </Container>

      {/* All this modals should be displayed inside notificationBox component  */}

      {isShowModalType == "announcement" && (
        <>
          <SendFeedbackModal
            show={isOpenModal == "send-feedback" && true}
            setShow={() => setIsOpenModal("")}
            // to show step count in heading
            // steps="1 out of 3"
            title="Tell us about your experience with Kate"
            detailsLabel="Share your feedback about the lesson"
          />
        </>
      )}
      {isShowModalType == "training-report" && (
        <>
          <ReportAProblemModal
            type="message-from-admin"
            show={isOpenModal == "report" && true}
            setShow={() => setIsOpenModal("")}
          />
          {/* <ReviewModal
            title="Tell us about your experience with John"
            show={isOpenModal == "leave-review" && true}
            setShow={() => setIsOpenModal("")}
            profileReviewData={{ review: { reviewsTypes: [], rating: 4, totalRating: 5 } }}
          /> */}
        </>
      )}

      {isShowModalType == "training-request" && (
        <>
          <CancelLesson
            show={isOpenModal == "cancel-lesson" && true}
            setShow={() => setIsOpenModal("")}
          />
        </>
      )}





      {/* <SendFeedbackModal
              show={true}
              title="We would be grateful for your feedback. This way we can get better."
              detailsLabel="Share your feedback about the lesson"
            /> */}
      {/* <SuccessFeedbackModal
              show={true} 
              title="Thank you!"
              description="You review was successfully sent."
            /> */}
      {/* <ReportProblemModal show={true} /> */}
      {/* <MobileReview
        show={true}
        title="Tell us about your experience with John"
      /> */}

      <MobileFooter />
      {/* <div className={classes.BottomTab}>
        <MobileBottomTab state={menuItem} menus={demoData} />
      </div> */}
    </div>
  );
};

export default NotificationsMobile;
